module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Hvilken ansættelse skal det tælle som?")]), _c('br'), _vm._v(" "), _c('select', {
    staticClass: "do-select",
    domProps: {
      "value": _vm.selectedEmploymentTitle
    },
    on: {
      "change": function($event) {
        return _vm.onChange($event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Vælg ansættelse")]), _vm._v(" "), _vm._l((_vm.employmentToSelectForRules), function(employmentsType) {
    return _c('option', {
      domProps: {
        "value": employmentsType
      }
    }, [_vm._v("\n      " + _vm._s(employmentsType) + "\n    ")])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2671dc56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettingsRules/SalaryRulesRule.vue
// module id = 1494
// module chunks = 1